/*
  <complete-the-look> — Complete-the-Look / cross-sell.
  Sprint 3/4 Part A + B. Data model: Shopify product recommendations with
  intent=complementary (curated in Search & Discovery) — so the relationships
  update WITHOUT code changes when products change (Part B). Degrades
  gracefully: renders nothing when no complementary products are set.

  - Individual selection (checkboxes) + "Add selected to bag".
  - Integrates with the AJAX cart via /cart/add.js and refreshes Dawn's cart
    drawer sections — it does NOT replace Dawn behaviour. Redirects to /cart as
    a fallback if the drawer isn't present.
  - Deferred, dependency-free, design-system styled, a11y + reduced-motion safe.
*/
(function () {
  if (customElements.get('complete-the-look')) return;

  class CompleteTheLook extends HTMLElement {
    connectedCallback() {
      this.pid = this.dataset.productId;
      this.base = this.dataset.url; // routes.product_recommendations_url
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.grid = this.querySelector('.sv-ctl__grid');
      this.addBtn = this.querySelector('.sv-ctl__add');
      if (!this.pid || !this.base || !this.grid) return;
      this.load();
    }

    async load() {
      try {
        const u = new URL(this.base + '.json', window.location.origin);
        u.searchParams.set('product_id', this.pid);
        u.searchParams.set('intent', 'complementary');
        u.searchParams.set('limit', '6');
        const res = await fetch(u.href);
        if (!res.ok) return;
        const products = (await res.json()).products || [];
        if (!products.length) return; // graceful: stay hidden
        this.render(products);
        this.removeAttribute('hidden');
      } catch (e) { /* graceful: stay hidden */ }
    }

    render(products) {
      const money = (cents) =>
        (window.Shopify && Shopify.currency ? '' : '') +
        new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
          style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
        }).format(cents / 100);

      this.grid.innerHTML = products.map((p) => {
        const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0] || {};
        const img = (p.featured_image || (p.images && p.images[0]) || '');
        return `<label class="sv-ctl__item" role="listitem">
          <input type="checkbox" class="sv-ctl__check" value="${v.id || ''}" ${v.id ? 'checked' : 'disabled'}>
          <img class="sv-ctl__img" src="${img}${img.includes('?') ? '&' : '?'}width=240" alt="" loading="lazy" width="120" height="150">
          <span class="sv-ctl__name">${p.title}</span>
          <span class="sv-ctl__price">${money(v.price != null ? v.price : p.price || 0)}</span>
        </label>`;
      }).join('');

      this.grid.addEventListener('change', () => this.sync());
      this.addBtn.addEventListener('click', () => this.addSelected());
      this.sync();
    }

    selected() {
      return [...this.grid.querySelectorAll('.sv-ctl__check:checked')].map((c) => c.value).filter(Boolean);
    }

    sync() {
      const n = this.selected().length;
      this.addBtn.disabled = n === 0;
      this.addBtn.textContent = n > 1 ? `Add ${n} to bag` : 'Add to bag';
    }

    async addSelected() {
      const ids = this.selected();
      if (!ids.length) return;
      this.addBtn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }),
        });
        if (!res.ok) throw new Error('add failed');
        await this.refreshCart();
      } catch (e) {
        window.location = this.cartUrl; // fallback, never replaces Dawn
      } finally {
        this.addBtn.disabled = false;
      }
    }

    // Refresh Dawn's cart drawer/bubble without owning cart logic.
    async refreshCart() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) { window.location = this.cartUrl; return; }
      try {
        const r = await fetch(`${this.cartUrl}?section_id=cart-drawer`);
        const html = new DOMParser().parseFromString(await r.text(), 'text/html');
        const fresh = html.querySelector('cart-drawer .drawer__inner') || html.querySelector('cart-drawer');
        const target = drawer.querySelector('.drawer__inner') || drawer;
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open(); else drawer.classList.add('active', 'animate');
      } catch (e) { window.location = this.cartUrl; }
    }
  }

  customElements.define('complete-the-look', CompleteTheLook);
})();
